import moment from 'moment';

const dateFromDateStart = (dateStart) => moment(dateStart);

export { dateFromDateStart };
